import { render, staticRenderFns } from "./gobierno.vue?vue&type=template&id=270834d8"
import script from "./gobierno.vue?vue&type=script&lang=js"
export * from "./gobierno.vue?vue&type=script&lang=js"
import style0 from "./gobierno.vue?vue&type=style&index=0&id=270834d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports